import Vue from "vue";
import Vuex from "vuex";
import account from './modules/account'
import productType from './modules/productType'
import product from './modules/product'
import home from './modules/home'
import feedback from './modules/feedback'
import accountManage from './modules/accountManage'
import article from './modules/article'
import addressManage from './modules/addressManage'
import myCollection from './modules/myCollection'
import user from './modules/user'
import follow from './modules/follow'
import cart from './modules/cart'
import member from './modules/member'
import memberAddress from './modules/memberAddress'
import transactionOrder from './modules/transactionOrder'
import order from './modules/order'
import share from './modules/share'
import shop from './modules/shop'
import memberRelation from './modules/memberRelation'
import pay from './modules/pay'
import transactionDetailApply from './modules/transactionDetailApply'
import shopArticle from './modules/shopArticle'
import memberVoucher from './modules/memberVoucher'
import memberIntegral from './modules/memberIntegral'
import transactionDetailTurnCoin from './modules/transactionDetailTurnCoin'
import memberPoster from './modules/memberPoster'
import productSeckill from  './modules/productSeckill'
import chat from './modules/chat'
import memberAgentCommission from './modules/memberAgentCommission'
import transactionDetailTurnCash from './modules/transactionDetailTurnCash'
import signIn from './modules/signIn'
import commandRecommend from './modules/commandRecommend'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    home,
    account,
    productType,
    product,
    feedback,
    accountManage,
    article,
    addressManage,
    myCollection,
    user,
    follow,
    cart,
    member,
    memberAddress,
    transactionOrder,
    order,
    share,
    shop,
    memberRelation,
    pay,
    transactionDetailApply,
    shopArticle,
    memberVoucher,
    memberIntegral,
    transactionDetailTurnCoin,
    memberPoster,
    productSeckill,
    chat,
    memberAgentCommission,
    transactionDetailTurnCash,
    signIn,
    commandRecommend
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js